export default "__VITE_ASSET__0uM9SUt0QC$A3bohcTHDOg__";